import { Content } from 'rsuite';
import styled from 'styled-components';

export const ContentStyled = styled(Content)`
  min-height: calc(100vh - 140px);
`;
